import { render, staticRenderFns } from "./cat-extend-detail.vue?vue&type=template&id=0b9383ac&"
import script from "./cat-extend-detail.vue?vue&type=script&lang=js&"
export * from "./cat-extend-detail.vue?vue&type=script&lang=js&"
import style0 from "./cat-extend-detail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports